import React, { useState, useEffect } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
  Box, Button, Input, Textarea, Flex, FormControl, FormLabel, Select, Image, Tag, TagLabel, TagCloseButton, useToast,
  Switch, NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, Heading, Text
} from '@chakra-ui/react';
import { supabase } from '../lib/supabaseClient';

const genreOptions = ['다큐멘터리', '로맨스', '액션', '드라마', '가족', '음악', '예능', '애니메이션', '공포', '스릴러', '코미디'];
const typeOptions = ['영화', '드라마', '예능', '애니메이션', '숏드라마', '다큐멘터리', '기타'];
const nationOptions = ['한국', '중국', '미국', '일본'];
const platformOptions = ['shortcha', 'watcha', 'netflix', 'tving', 'wavve', 'MBN', 'YouTube', 'Disney+', 'ENA', 'naverTV', 'U+Mobile', 'Always'];
const platformTagOptions = ['Laeebly', '시월뮤직', '해브앤컴퍼니', '레타뮤직'];

export default function VideoRegisterModal({ isOpen, onClose, video, onComplete }) {
  const toast = useToast();
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnailFile, setThumbnailFile] = useState(null);
  const [copyrightsHolderList, setCopyrightsHolderList] = useState([]);
  const [copyrightsHolderId, setCopyrightsHolderId] = useState('');
  const [copyrightsHolderName, setCopyrightsHolderName] = useState('');
  const [title, setTitle] = useState('');
  const [published_year, setPublishedYear] = useState('');
  const [introduction, setIntroduction] = useState('');
  const [director, setDirector] = useState('');
  const [cast, setCast] = useState('');
  const [genre, setGenre] = useState('');
  const [video_type, setVideoType] = useState('');
  const [nation, setNation] = useState('');
  const [platform, setPlatform] = useState('');
  const [profit_share, setProfitShare] = useState('');
  const [platform_link, setPlatformLink] = useState('');
  const [trailer_url, setTrailerUrl] = useState('');
  const [download_link, setDownloadLink] = useState('');
  const [guide, setGuide] = useState('');
  const [comments, setComments] = useState('');
  const [platformTags, setPlatformTags] = useState(['Laeebly']);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [whitelist, setWhitelist] = useState('None');
  const [scope, setScope] = useState('전체');
  const [notes, setNotes] = useState('');
  const [isLongform, setIsLongform] = useState(false);
  const [isNaverClip, setIsNaverClip] = useState(false);
  const [channelType, setChannelType] = useState('A');
  const [copyrightsLaeebly, setCopyrightsLaeebly] = useState('쉐어하지 않음(100%레이블리)');
  const [creatorLaeebly, setCreatorLaeebly] = useState('쉐어하지 않음(100%레이블리)');
  
  // 음원 수익 배분율
  const [shareMusicLaeebly, setShareMusicLaeebly] = useState(0);
  const [shareMusicCreator, setShareMusicCreator] = useState(0);
  const [shareMusicCopyright, setShareMusicCopyright] = useState(0);
  
  // 영상 수익 배분율
  const [shareVideoLaeebly, setShareVideoLaeebly] = useState(0);
  const [shareVideoCreator, setShareVideoCreator] = useState(0);
  const [shareVideoCopyright, setShareVideoCopyright] = useState(0);

  // 쇼핑 수익 배분율
  const [shareShoppingLaeebly, setShareShoppingLaeebly] = useState(0);
  const [shareShoppingCreator, setShareShoppingCreator] = useState(0);
  const [shareShoppingCopyright, setShareShoppingCopyright] = useState(0);

  // 공개상태와 식별코드 추가
  const [open, setOpen] = useState(true);
  const [identificationCode, setIdentificationCode] = useState('');
  const [deadlineBool, setDeadlineBool] = useState(false);

  // Constants for select options
  const whitelistOptions = ['1차', '2차', 'None'];
  const scopeOptions = ['전체', '일부'];
  const channelTypeOptions = [
    { label: '브랜드 채널', value: 'A' },
    { label: '일반 채널', value: 'D' }
  ];
  const shareOptions = [
    '쉐어하지 않음(100%레이블리)',
    '음원+영상',
    '음원만',
    '음원+영상+쇼핑태그'
  ];

  // 폼 초기화 함수
  const resetForm = () => {
    setSelectedCompany('');
    setThumbnail(null);
    setThumbnailFile(null);
    setCopyrightsHolderId('');
    setCopyrightsHolderName('');
    setTitle('');
    setPublishedYear('');
    setIntroduction('');
    setDirector('');
    setCast('');
    setGenre('');
    setVideoType('');
    setNation('');
    setPlatform('');
    setProfitShare('');
    setPlatformLink('');
    setTrailerUrl('');
    setDownloadLink('');
    setGuide('');
    setComments('');
    setPlatformTags(['Laeebly']);
    setWhitelist('None');
    setScope('전체');
    setNotes('');
    setIsLongform(false);
    setIsNaverClip(false);
    setChannelType('A');
    setCopyrightsLaeebly('쉐어하지 않음(100%레이블리)');
    setCreatorLaeebly('쉐어하지 않음(100%레이블리)');
    setShareMusicLaeebly(0);
    setShareMusicCreator(0);
    setShareMusicCopyright(0);
    setShareVideoLaeebly(0);
    setShareVideoCreator(0);
    setShareVideoCopyright(0);
    setShareShoppingLaeebly(0);
    setShareShoppingCreator(0);
    setShareShoppingCopyright(0);
    setOpen(true);
    setIdentificationCode('');
    setDeadlineBool(false);
  };

  // 모달이 열릴 때 폼 초기화
  useEffect(() => {
    if (isOpen && !video) {
      resetForm();
    }
  }, [isOpen, video]);

  useEffect(() => {
    if (video) {
      setSelectedCompany(video.company || '');
      setThumbnail(video.thumbnail || null);
      setCopyrightsHolderId(video.copyrights_holder_id || '');
      setCopyrightsHolderName(video.copyrights_holder_name || '');
      setTitle(video.title || '');
      setPublishedYear(video.published_year || '');
      setIntroduction(video.introduction || '');
      setDirector(video.director || '');
      setCast(video.cast || '');
      setGenre(video.genre || '');
      setVideoType(video.video_type || '');
      setNation(video.nation || '');
      setPlatform(video.ott || '');
      setProfitShare(video.profit_share || '');
      setPlatformLink(video.url_submit_link || '');
      setTrailerUrl(video.trailer_url || '');
      setDownloadLink(video.download_link || '');
      setGuide(video.guide || '');
      setComments(video.comments || '');
      setPlatformTags(video.subapp ? [video.subapp] : ['Laeebly']);
      setWhitelist(video.whitelist || 'None');
      setScope(video.scope || '전체');
      setNotes(video.notes || '');
      setIsLongform(video.is_longform || false);
      setIsNaverClip(video.is_naver_clip || false);
      setChannelType(video.channel_type || 'A');
      setCopyrightsLaeebly(video.copyrights_laeebly || '쉐어하지 않음(100%레이블리)');
      setCreatorLaeebly(video.creator_laeebly || '쉐어하지 않음(100%레이블리)');
      setShareMusicLaeebly(video.share_music_laeebly || 0);
      setShareMusicCreator(video.share_music_creator || 0);
      setShareMusicCopyright(video.share_music_copyright || 0);
      setShareVideoLaeebly(video.share_video_laeebly || 0);
      setShareVideoCreator(video.share_video_creator || 0);
      setShareVideoCopyright(video.share_video_copyright || 0);
      setShareShoppingLaeebly(video.share_shopping_laeebly || 0);
      setShareShoppingCreator(video.share_shopping_creator || 0);
      setShareShoppingCopyright(video.share_shopping_copyright || 0);
      setOpen(video.open || true);
      setIdentificationCode(video.identification_code || '');
      setDeadlineBool(video.deadline_bool || false);
    }
  }, [video]);

  // 권리자 목록 불러오기
  useEffect(() => {
    async function fetchCopyrightsHolders() {
      const { data, error } = await supabase
        .from('user')
        .select('id, name, email, role');
      if (data) {
        const filtered = data.filter(u => u.role && u.role.includes('Copyrights Holder'));
        setCopyrightsHolderList(filtered);
      }
    }
    fetchCopyrightsHolders();
  }, []);

  // 회사 목록 불러오기
  useEffect(() => {
    async function fetchCompanies() {
      const { data, error } = await supabase
        .from('content_company')
        .select('company_name');
      if (data) {
        setCompanyList(data);
      }
    }
    fetchCompanies();
  }, []);

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setThumbnail(URL.createObjectURL(file));
      setThumbnailFile(file);
    }
  };

  const handleTagRemove = (removedTag) => {
    setPlatformTags(tags => tags.filter(tag => tag !== removedTag));
  };

  const handleCopyrightsHolderChange = (e) => {
    const id = e.target.value;
    setCopyrightsHolderId(id);
    const selected = copyrightsHolderList.find(u => String(u.id) === id);
    setCopyrightsHolderName(selected ? selected.name : '');
  };

  // 랜덤 5글자 생성 함수
  function generateRandomCode(length = 5) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    let thumbnailUrl = video?.thumbnail || '';
    // 1. 썸네일 업로드
    if (thumbnailFile) {
      const fileExt = thumbnailFile.name.split('.').pop();
      const fileName = `${Date.now()}.${fileExt}`;
      const { data, error } = await supabase.storage.from('video').upload(fileName, thumbnailFile);
      if (error) {
        toast({ title: '썸네일 업로드 실패', status: 'error' });
        setIsSubmitting(false);
        return;
      }
      const { data: urlData } = supabase.storage.from('video').getPublicUrl(fileName);
      thumbnailUrl = urlData.publicUrl;
    }

    const videoData = {
      company: selectedCompany,
      copyrights_holder_name: copyrightsHolderName,
      copyrights_holder_id: copyrightsHolderId,
      title,
      published_year,
      introduction,
      director,
      cast,
      genre,
      video_type,
      nation,
      ott: platform,
      profit_share,
      url_submit_link: platform_link,
      trailer_url,
      download_link,
      guide,
      comments,
      thumbnail: thumbnailUrl,
      subapp: platformTags[0],
      whitelist,
      scope,
      notes,
      is_longform: isLongform,
      is_naver_clip: isNaverClip,
      channel_type: channelType,
      copyrights_laeebly: copyrightsLaeebly,
      creator_laeebly: creatorLaeebly,
      share_music_laeebly: shareMusicLaeebly,
      share_music_creator: shareMusicCreator,
      share_music_copyright: shareMusicCopyright,
      share_video_laeebly: shareVideoLaeebly,
      share_video_creator: shareVideoCreator,
      share_video_copyright: shareVideoCopyright,
      share_shopping_laeebly: shareShoppingLaeebly,
      share_shopping_creator: shareShoppingCreator,
      share_shopping_copyright: shareShoppingCopyright,
      open: open,
      identification_code: identificationCode,
      deadline_bool: deadlineBool,
    };
    
    if (video) {
      // Update
      const { error: updateError } = await supabase
        .from('licensed_video')
        .update(videoData)
        .eq('id', video.id);
        
      setIsSubmitting(false);
      if (updateError) {
        toast({ title: '수정 실패', status: 'error' });
      } else {
        toast({ title: '수정 완료', status: 'success' });
        onClose();
        if (onComplete) onComplete();
      }
    } else {
      // Insert
      const { error: insertError } = await supabase.from('licensed_video').insert({
        ...videoData,
        identification_code: identificationCode || generateRandomCode(5),
        created_date: new Date().toISOString(),
      });

      setIsSubmitting(false);
      if (insertError) {
        toast({ title: '저장 실패', status: 'error' });
      } else {
        toast({ title: '저장 완료', status: 'success' });
        onClose();
        if (onComplete) onComplete();
      }
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent maxW="1200px">
        <ModalHeader>{video ? '영상 수정' : '영상 등록'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Flex gap={6}>
            {/* 썸네일 업로드 */}
            <Box w="240px" h="320px" bg="gray.100" borderRadius="md" overflow="hidden" display="flex" alignItems="center" justifyContent="center">
              {thumbnail ? (
                <Image src={thumbnail} alt="thumbnail" w="100%" h="100%" objectFit="cover" />
              ) : (
                <FormLabel htmlFor="thumbnail-upload" w="100%" h="100%" m={0} display="flex" alignItems="center" justifyContent="center" cursor="pointer">
                  Click to upload an image
                  <Input id="thumbnail-upload" type="file" accept="image/*" display="none" onChange={handleThumbnailChange} />
                </FormLabel>
              )}
            </Box>
            {/* 입력 폼 */}
            <Box flex={1}>
              <form onSubmit={handleSubmit}>
                <FormControl mb={2}>
                  <FormLabel>회사 선택</FormLabel>
                  <Select 
                    value={selectedCompany} 
                    onChange={e => setSelectedCompany(e.target.value)}
                    placeholder="회사를 선택하세요"
                    required
                  >
                    {companyList.map(company => (
                      <option key={company.company_name} value={company.company_name}>
                        {company.company_name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
                {/* <FormControl mb={2}>
                  <FormLabel>영상 권리자 선택</FormLabel>
                  <Select value={copyrightsHolderId} onChange={handleCopyrightsHolderChange} required>
                    <option value="">선택</option>
                    {copyrightsHolderList.map(u => (
                      <option key={u.id} value={u.id}>{u.name} ({u.email})</option>
                    ))}
                  </Select>
                </FormControl> */}
                <FormControl mb={2}>
                  <FormLabel>작품 제목</FormLabel>
                  <Input value={title} onChange={e => setTitle(e.target.value)} required />
                </FormControl>
                <FormControl mb={2}>
                  <FormLabel>개봉년도</FormLabel>
                  <Input value={published_year} onChange={e => setPublishedYear(e.target.value)} />
                </FormControl>
                <FormControl mb={2}>
                  <FormLabel>작품 소개</FormLabel>
                  <Textarea value={introduction} onChange={e => setIntroduction(e.target.value)} />
                </FormControl>
                <FormControl mb={2}>
                  <FormLabel>감독</FormLabel>
                  <Input value={director} onChange={e => setDirector(e.target.value)} />
                </FormControl>
                <FormControl mb={2}>
                  <FormLabel>출연</FormLabel>
                  <Input value={cast} onChange={e => setCast(e.target.value)} />
                </FormControl>
                <Flex gap={2}>
                  <FormControl mb={2} flex={1}>
                    <FormLabel>장르</FormLabel>
                    <Select value={genre} onChange={e => setGenre(e.target.value)} required>
                      <option value="">선택</option>
                      {genreOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </Select>
                  </FormControl>
                  <FormControl mb={2} flex={1}>
                    <FormLabel>영상 타입</FormLabel>
                    <Select value={video_type} onChange={e => setVideoType(e.target.value)} required>
                      <option value="">선택</option>
                      {typeOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </Select>
                  </FormControl>
                </Flex>
                <Flex gap={2}>
                  <FormControl mb={2} flex={1}>
                    <FormLabel>개봉 국가</FormLabel>
                    <Select value={nation} onChange={e => setNation(e.target.value)} required>
                      <option value="">선택</option>
                      {nationOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </Select>
                  </FormControl>
                  <FormControl mb={2} flex={1}>
                    <FormLabel>영상 공개 플랫폼</FormLabel>
                    <Select value={platform} onChange={e => setPlatform(e.target.value)} required>
                      <option value="">선택</option>
                      {platformOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                    </Select>
                  </FormControl>
                </Flex>
                {/* <FormControl mb={2}>
                  <FormLabel>수수료율</FormLabel>
                  <Input value={profit_share} onChange={e => setProfitShare(e.target.value)} />
                </FormControl> */}
                <FormControl mb={2}>
                  <FormLabel>플랫폼 영상 링크</FormLabel>
                  <Input value={platform_link} onChange={e => setPlatformLink(e.target.value)} />
                </FormControl>
                <FormControl mb={2}>
                  <FormLabel>영상 예고영상 링크</FormLabel>
                  <Input value={trailer_url} onChange={e => setTrailerUrl(e.target.value)} />
                </FormControl>
                <FormControl mb={2}>
                  <FormLabel>원본 다운로드 링크</FormLabel>
                  <Input value={download_link} onChange={e => setDownloadLink(e.target.value)} />
                </FormControl>
                <FormControl mb={2}>
                  <FormLabel>숏츠 제작 가이드</FormLabel>
                  <Textarea value={guide} onChange={e => setGuide(e.target.value)} />
                </FormControl>
                <FormControl mb={2}>
                  <FormLabel>숏츠 제작시 별도 안내 사항</FormLabel>
                  <Textarea value={comments} onChange={e => setComments(e.target.value)} />
                </FormControl>
                <FormControl mb={2}>
                  <FormLabel>플랫폼 선택</FormLabel>
                  <Select value={platformTags[0]} onChange={e => setPlatformTags([e.target.value])} required>
                    {platformTagOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                  </Select>
                </FormControl>
                <Flex gap={2}>
                  <FormControl mb={2} flex={1}>
                    <FormLabel>공개상태</FormLabel>
                    <Select value={open} onChange={e => setOpen(e.target.value === 'true')}>
                      <option value="true">공개</option>
                      <option value="false">비공개</option>
                    </Select>
                  </FormControl>
                  <FormControl mb={2} flex={1}>
                    <FormLabel>식별코드</FormLabel>
                    <Input 
                      value={identificationCode} 
                      onChange={e => setIdentificationCode(e.target.value)}
                      placeholder="자동 생성되거나 수동 입력"
                    />
                  </FormControl>
                </Flex>
                <FormControl mb={2}>
                  <FormLabel>선착순 마감</FormLabel>
                  <Flex align="center" gap={2}>
                    <Switch isChecked={deadlineBool} onChange={e => setDeadlineBool(e.target.checked)} />
                    <Text fontSize="sm" color="gray.600">
                      {deadlineBool ? '마감됨' : '진행중'}
                    </Text>
                  </Flex>
                </FormControl>
                <Box borderWidth={1} borderRadius="md" p={4} mb={4}>
                  <Heading size="sm" mb={4}>추가 정보</Heading>
                  <FormControl mb={2}>
                    <FormLabel>Whitelist</FormLabel>
                    <Select value={whitelist} onChange={e => setWhitelist(e.target.value)}>
                      {whitelistOptions.map(option => (
                        <option key={option} value={option}>{option}</option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl mb={2}>
                    <FormLabel>Scope</FormLabel>
                    <Select value={scope} onChange={e => setScope(e.target.value)}>
                      {scopeOptions.map(option => (
                        <option key={option} value={option}>{option}</option>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl mb={2}>
                    <FormLabel>Notes</FormLabel>
                    <Textarea value={notes} onChange={e => setNotes(e.target.value)} />
                  </FormControl>
                  <Flex gap={4} mb={4}>
                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb={0}>롱폼 여부</FormLabel>
                      <Switch isChecked={isLongform} onChange={e => setIsLongform(e.target.checked)} />
                    </FormControl>
                    <FormControl display="flex" alignItems="center">
                      <FormLabel mb={0}>네이버 클립 여부</FormLabel>
                      <Switch isChecked={isNaverClip} onChange={e => setIsNaverClip(e.target.checked)} />
                    </FormControl>
                    <FormControl>
                      <FormLabel>채널 타입</FormLabel>
                      <Select value={channelType} onChange={e => setChannelType(e.target.value)}>
                        {channelTypeOptions.map(option => (
                          <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                      </Select>
                    </FormControl>
                  </Flex>
                  <Flex gap={4} mb={4}>
                    <FormControl>
                      <FormLabel>Copyrights Laeebly</FormLabel>
                      <Select value={copyrightsLaeebly} onChange={e => setCopyrightsLaeebly(e.target.value)}>
                        {shareOptions.map(option => (
                          <option key={option} value={option}>{option}</option>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl>
                      <FormLabel>Creator Laeebly</FormLabel>
                      <Select value={creatorLaeebly} onChange={e => setCreatorLaeebly(e.target.value)}>
                        {shareOptions.map(option => (
                          <option key={option} value={option}>{option}</option>
                        ))}
                      </Select>
                    </FormControl>
                  </Flex>
                </Box>

                <Box borderWidth={1} borderRadius="md" p={4} mb={4}>
                  <Heading size="sm" mb={4}>음원 수익 배분율</Heading>
                  <Flex gap={4}>
                    <FormControl>
                      <FormLabel>Laeebly</FormLabel>
                      <NumberInput value={shareMusicLaeebly} onChange={(_, val) => setShareMusicLaeebly(val)} min={0} max={100}>
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>
                    <FormControl>
                      <FormLabel>크리에이터</FormLabel>
                      <NumberInput value={shareMusicCreator} onChange={(_, val) => setShareMusicCreator(val)} min={0} max={100}>
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>
                    <FormControl>
                      <FormLabel>저작권자</FormLabel>
                      <NumberInput value={shareMusicCopyright} onChange={(_, val) => setShareMusicCopyright(val)} min={0} max={100}>
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>
                  </Flex>
                </Box>

                <Box borderWidth={1} borderRadius="md" p={4} mb={4}>
                  <Heading size="sm" mb={4}>영상 수익 배분율</Heading>
                  <Flex gap={4}>
                    <FormControl>
                      <FormLabel>Laeebly</FormLabel>
                      <NumberInput value={shareVideoLaeebly} onChange={(_, val) => setShareVideoLaeebly(val)} min={0} max={100}>
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>
                    <FormControl>
                      <FormLabel>크리에이터</FormLabel>
                      <NumberInput value={shareVideoCreator} onChange={(_, val) => setShareVideoCreator(val)} min={0} max={100}>
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>
                    <FormControl>
                      <FormLabel>저작권자</FormLabel>
                      <NumberInput value={shareVideoCopyright} onChange={(_, val) => setShareVideoCopyright(val)} min={0} max={100}>
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>
                  </Flex>
                </Box>

                <Box borderWidth={1} borderRadius="md" p={4} mb={4}>
                  <Heading size="sm" mb={4}>쇼핑 수익 배분율</Heading>
                  <Flex gap={4}>
                    <FormControl>
                      <FormLabel>Laeebly</FormLabel>
                      <NumberInput value={shareShoppingLaeebly} onChange={(_, val) => setShareShoppingLaeebly(val)} min={0} max={100}>
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>
                    <FormControl>
                      <FormLabel>크리에이터</FormLabel>
                      <NumberInput value={shareShoppingCreator} onChange={(_, val) => setShareShoppingCreator(val)} min={0} max={100}>
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>
                    <FormControl>
                      <FormLabel>저작권자</FormLabel>
                      <NumberInput value={shareShoppingCopyright} onChange={(_, val) => setShareShoppingCopyright(val)} min={0} max={100}>
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    </FormControl>
                  </Flex>
                </Box>

                <Flex mt={6} justify="flex-end" gap={2}>
                  <Button onClick={onClose}>취소</Button>
                  <Button colorScheme="blue" type="submit" isLoading={isSubmitting}>{video ? '수정' : '등록'}</Button>
                </Flex>
              </form>
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
} 